class HeaderEvent {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    if (window.matchMedia('(max-width: 767px)').matches) {
      //クリックで動く
      $('.js-ham-trigger').click(function(){
        $(this).toggleClass('is-open');
        $("body").toggleClass('no_scroll');
        $('.js-ham-container').slideToggle();
      });
      $('.js-ham-childAcc').click(function(){
        $(this).find(".c-ham__plus").toggleClass('is-open');
        $(this).next().slideToggle();
      });
    }

    if (window.matchMedia('(min-width: 768px)').matches) {
      const header = document.querySelector(".top-header")
      const megaMenu = document.querySelector(".js-megaMenuContent")

      if(document.querySelector(".p-top__mv")){
        const mv_Y = document.querySelector(".p-top__mv").clientHeight;
        window.addEventListener("scroll", () => {
          let scroll_Y = window.scrollY;
          // console.log(scroll_Y);
          if(mv_Y < scroll_Y){
            header.classList.add("is-over")
            megaMenu.classList.add("is-over")

          }else{
            header.classList.remove("is-over")
            megaMenu.classList.remove("is-over")
          }
        })
      }


      const megaMenuTrigger = document.querySelector(".js-megaMenu ")

      megaMenuTrigger.addEventListener("mouseover", () => {
        megaMenuTrigger.classList.add("is-active")
        megaMenu.classList.add("is-active")
      })
      megaMenuTrigger.addEventListener("mouseleave", () => {
        megaMenuTrigger.classList.remove("is-active")
        megaMenu.classList.remove("is-active")
      })


    }





  }
}